import { render, staticRenderFns } from "./ParcelHeader.vue?vue&type=template&id=1b473711&scoped=true&"
import script from "./ParcelHeader.vue?vue&type=script&lang=js&"
export * from "./ParcelHeader.vue?vue&type=script&lang=js&"
import style0 from "./ParcelHeader.vue?vue&type=style&index=0&id=1b473711&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b473711",
  null
  
)

export default component.exports